import { createContext, useState } from "react";

export const MSContext = createContext();

const intialMSFilters = {
    fullName: "",
    emailId: "",
    religion: "",
    caste: "",
    subCaste: "",
    mobile: "",
    _accountStatus: "",
    subscription: "",
    createdAt: "",
    updatedAt: "",
    startDate:"",
    endDate:"",
    invited_by:""
  }

export const MSProvider = ({ children }) => {
  const [msSearchTerm, setMsSearchTerm] = useState("");
  const [msFilters, setMsFilters] = useState(intialMSFilters);
  const [ContextCurrentPage, contextSetCurrentPage] = useState(1);
  const [ContextTotalPages, contextSetTotalPages] = useState(0);
  const [Contextlimit] = useState(20);
  const [ContextReload, ContextSetReload] = useState(false);

  return (
    <MSContext.Provider
      value={{
        msSearchTerm,
        setMsSearchTerm,
        msFilters,
        setMsFilters,
        intialMSFilters,
        ContextCurrentPage,
        contextSetCurrentPage,
        ContextTotalPages,
        contextSetTotalPages,
        Contextlimit,
        ContextReload,
        ContextSetReload,
      }}
    >
      {children}
    </MSContext.Provider>
  );
};
